import type { ActionIconProps } from '@mantine/core';
import { ActionIcon } from '@mantine/core';

import styles from './ActionButton.module.css';

export const LBActionButton = ({
  children,
  className,
  ...props
}: ActionIconProps & { onClick?: () => void }) => (
  <ActionIcon className={`${styles.icon} ${className}`} {...props}>
    {children}
  </ActionIcon>
);
